import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, ActivatedRoute, Params, RouterModule } from "@angular/router";
import { AppUserService } from "../../services/appuser.service";
import { IUser } from "../../interfaces/ilogin";
import { IAzureAuthentication } from "../../interfaces/iazureauthentication";
import { IAppStore } from "../../iappstore";
import { Store } from "@ngrx/store";
import { SetSelectedBusinessFunctionAction, SetUserDetailsAction } from "../../actions/applicationuser.action";
import { SetTokenAction } from "../../actions/azureauthentication.action";

@Component({
    selector: "deloittead",
    templateUrl: "./deloittead.component.html",
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class DeloitteAdComponent implements OnInit {
    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private appUserService: AppUserService,
        private store: Store<IAppStore>) {

    }

    ngOnInit(): void {
        this.activatedRoute.fragment.subscribe((params: string) => {
            let token: any = this.parseFragmentForToken(params);
            //const token: string = params["id_token"];
            // save token
            if (typeof token !== "undefined" && token) {
                this.store.dispatch(new SetTokenAction({token: token} as IAzureAuthentication));

                this.appUserService.getUser().subscribe((user: IUser) => {
                    // Transform roles to string array if they exist
                    let transformedRoles: string[] = [];
                    if (user.roles && Array.isArray(user.roles)) {
                        transformedRoles = user.roles.map((e: any) => {
                            return e.name || e;
                        });
                    }

                    // Create a new user object with transformed roles
                    const userWithTransformedRoles: IUser = {
                        ...user,
                        roles: transformedRoles
                    };

                    this.store.dispatch(new SetUserDetailsAction(userWithTransformedRoles));

                    if (user.businessFunctions && user.businessFunctions.length > 1) {
                        this.router.navigate(["/businessfunctionselection"]);
                    } else {
                        // the user only belongs to one business function so set it
                        // and redirect to the home page
                        this.store.dispatch(new SetSelectedBusinessFunctionAction(user.businessFunctions[0]));
                        this.router.navigate(["/home"]);
                    }
                });
            } else {
                this.router.navigate(["/unauthorized"]);
            }
        });
    }

    private parseFragmentForToken(fragment: string): string {
        const params = new URLSearchParams(fragment);
        return params.get('id_token') || '';
    }
}
